<!-- Template -->

<template> 
    <div class="tab-content horizontal">
        <div class="tab-pane fade show active">

            <table class="table with-header">

                <thead>
                    <tr>
                        <th>Today</th>
                        <th>&nbsp;</th>
                        <th class="r">Date/Time</th>
                    </tr>
                </thead>

                <tbody>

                    <tr>
                        <td>Ticket closed</td>
                        <td>
                            <a class="open-system">17982 AlignRT software crash when importin..</a>
                            <p>898-9879 AlignRT</p>
                        </td>
                        <td class="r">
                            11 May 2019
                            <p>12:05</p>
                        </td>
                    </tr>

                    <tr>
                        <td>Ticket closed</td>
                        <td>
                            <a class="open-system">17982 AlignRT software crash when importin..</a>
                            <p>898-9879 AlignRT</p>
                        </td>
                        <td class="r">
                            11 May 2019
                            <p>12:05</p>
                        </td>
                    </tr>

                    <tr>
                        <td>Ticket closed</td>
                        <td>
                            <a class="open-system">17982 AlignRT software crash when importin..</a>
                            <p>898-9879 AlignRT</p>
                        </td>
                        <td class="r">
                            11 May 2019
                            <p>12:05</p>
                        </td>
                    </tr>

                    <tr>
                        <td>Ticket closed</td>
                        <td>
                            <a class="open-system">17982 AlignRT software crash when importin..</a>
                            <p>898-9879 AlignRT</p>
                        </td>
                        <td class="r">
                            11 May 2019
                            <p>12:05</p>
                        </td>
                    </tr>

                </tbody>
            </table>

            <table class="table with-header">

                <thead>
                    <tr>
                        <th>Earlier</th>
                        <th>&nbsp;</th>
                        <th>&nbsp;</th>
                    </tr>
                </thead>

                <tbody>

                    <tr>
                        <td>Ticket closed</td>
                        <td>
                            <a class="open-system">17982 AlignRT software crash when importin..</a>
                            <p>898-9879 AlignRT</p>
                        </td>
                        <td class="r">
                            11 May 2019
                            <p>12:05</p>
                        </td>
                    </tr>

                    <tr>
                        <td>Ticket closed</td>
                        <td>
                            <a class="open-system">17982 AlignRT software crash when importin..</a>
                            <p>898-9879 AlignRT</p>
                        </td>
                        <td class="r">
                            11 May 2019
                            <p>12:05</p>
                        </td>
                    </tr>

                    <tr>
                        <td>Ticket closed</td>
                        <td>
                            <a class="open-system">17982 AlignRT software crash when importin..</a>
                            <p>898-9879 AlignRT</p>
                        </td>
                        <td class="r">
                            11 May 2019
                            <p>12:05</p>
                        </td>
                    </tr>

                    <tr>
                        <td>Ticket closed</td>
                        <td>
                            <a class="open-system">17982 AlignRT software crash when importin..</a>
                            <p>898-9879 AlignRT</p>
                        </td>
                        <td class="r">
                            11 May 2019
                            <p>12:05</p>
                        </td>
                    </tr>

                </tbody>
            </table>

        </div>
    </div>   
</template>

<!-- Script -->

<script>
    export default {
        name: 'ActivityContent',

        props: [
            'hospital'
        ]
    }
</script>

